import RunConfigService from './runConfigService.js';
import UrlService from './urlService.js';

// Set constant for default Language
const DEFAULT_LANGUAGE = 'en';
// Set constant for default Country
const DEFAULT_COUNTRY = 'US';
/**
 * Set constant for default customLabel key for translation objects
 * For edge cases like the label for State - Label maybe called
 * Province/Region/Territory, labels like this go in this object within translations object
 */
const DEFAULT_CUSTOM_LABEL_KEY = 'customLabels';

class TranslationsUtil {
    constructor (language, country, fileTranslations) {
        this.language = language || RunConfigService.getRunConfig().language || DEFAULT_LANGUAGE;
        this.country = country || RunConfigService.getRunConfig().country || DEFAULT_COUNTRY;
        this.fileTranslations = fileTranslations;
        this.selectedFileTranslations = this._verifySelectedDefaultTranslations(this.language);
    }

    static get CUSTOM_LABEL_KEY () {
        return DEFAULT_CUSTOM_LABEL_KEY;
    }

    _verifySelectedDefaultTranslations (language) {
    // Set to Default Language and Country if not found
        if (!this.fileTranslations[language]) {
            language = DEFAULT_LANGUAGE;
        }

        return this.fileTranslations[language];
    }

    getDefaultTranslations () {
        let labelsObj = {};
        Object.entries(this.selectedFileTranslations).forEach(([key, value]) => {
            if (key !== DEFAULT_CUSTOM_LABEL_KEY) {
                labelsObj[key] = value;
            } else {
                let labelKey = this.selectedFileTranslations[DEFAULT_CUSTOM_LABEL_KEY];
                let customLabel = labelKey[this.country] ? labelKey[this.country] : labelKey[DEFAULT_COUNTRY];
                labelsObj = Object.assign(customLabel, labelsObj);
            }
        });
        return labelsObj;
    }

    /**
   * Gets translations from server if they don't already exist
   * @param {*} pagePath Path after the locale page, ex. shop/adp-manage
   * @returns serverTranslations object
   */
    async getServerTranslations (pagePath) {
        let baseUrl = RunConfigService.getBaseUrl();
        let translationsUrl = `${baseUrl}${UrlService.getLocaleUrl()}${pagePath}.service.tdc.json`;
        let data = await fetch(translationsUrl, {
            method: 'GET',
            credentials: 'omit'
        });
        return data.ok ? this._removeTdcPrefixes(await data.json()) : {};
    }

    /**
   * The object that is returned by the fetch in getServerTranslations contains a list of string key/value pairs.
   * Each key starts with tdc_, (e.g. tdc_shippingLabel), which needs to be removed for the string names to match
   * the component string names. (e.g. shippingLabel)
   * @param tdcServerStrings
   */
    _removeTdcPrefixes (tdcServerStrings) {
        let serverStrings = {};
        Object.entries(tdcServerStrings).forEach(([key, value]) => {
            key = key.replace('tdc_', '');
            serverStrings[key] = value;
        });
        return serverStrings;
    }
}

export default TranslationsUtil;
